var isRunningOnServer = function () {
    return typeof window === undefined;
};
export var autoResizeTextArea = function (event) {
    var target = event.target;
    target.style.height = 'auto';
    target.style.height = target.scrollHeight + target.offsetHeight - target.clientHeight + "px";
};
export var safeBase64Encode = function (value) {
    var ENC = {
        '+': '-',
        '/': '_',
        '=': '.',
    };
    var base64Value = isRunningOnServer()
        ? Buffer.from(value).toString('base64')
        : window.btoa(value);
    return base64Value.replace(/[+/=]/g, function (m) { return ENC[m]; });
};
export var preLoadImgIfIsRunningOnBrowser = function (url) {
    if (!isRunningOnServer()) {
        var image = new window.Image();
        image.src = url;
    }
};
